<template>
  <el-dialog
    class="radish-dia"
    title="请选择要挂到的人选"
    top="70px"
    :modal="false"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div class="radish-dia-body" style="padding-bottom:10px">
      <div v-if="dupRadishData.length > 0" style="padding: 5px 0">
        <div>根据姓名+公司；姓名+学校；两种方式匹配与系统人选，该简历可能属于以下人选，请选择要挂到的人选</div>
        <el-table border size="mini" :resizable="false" :data="dupRadishData" style="width: 100%">
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="doAttach(scope.row)">选择</el-button>
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="姓名" width="60"> </el-table-column>
          <el-table-column label="公司" prop="公司"></el-table-column>
          <el-table-column label="部门" prop="部门"></el-table-column>
          <el-table-column label="职能模块" prop="职能模块"></el-table-column>
          <el-table-column label="手机" prop="手机"></el-table-column>
        </el-table>
      </div>
      <el-button type="primary" size="mini" @click="doCreate">直接新建人选</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    handleAttach: { type: Function, default: () => {} },
    handleCreate: { type: Function, default: () => {} },
  },
  data: function() {
    return {
      dialogVisible: false,
      dupRadishData: [],
    }
  },
  methods: {
    show: function(radishes) {
      // console.log(radishes)
      this.dialogVisible = true
      this.dupRadishData = radishes
    },
    doAttach: function(row) {
      this.handleAttach(row)
      this.dialogVisible = false
    },
    doCreate: function() {
      this.handleCreate()
      this.dialogVisible = false
    },
  },
}
</script>
